import { httpAxios } from "../utils/httpAxios"


export const authLogin = async(data)=>{
    const response = await httpAxios.post('/user/login',data)
    .then((res)=>{
        return res.data
    })
    .catch((err)=>{
        return err.response.data
    })

    return response;
}
export const authSignup = async(data)=>{
    const response = await httpAxios.post('/user/registration/post',data)
    .then((res)=>{
        return res.data
    })
    .catch((err)=>{
        return err.response.data
    })

    return response;
}
export const authverificationType = async(id, verifyType)=>{
    const formdat = new FormData();
    formdat.append("user_id", id)
    formdat.append("verify_by", verifyType)
    const response = await httpAxios.post('/user/verification/type',formdat)
    .then((res)=>{
        return res.data
    })
    .catch((err)=>{
        return err.response.data
    })

    return response;
}
export const authSignupOtp = async(email_otp, idotp, verifyType)=>{
    const formdat = new FormData();
    formdat.append("user_id", idotp)
    formdat.append("otp", email_otp)
    formdat.append("verify_by", verifyType)
    const response = await httpAxios.post('/user/verification',formdat)
    .then((res)=>{
        return res.data
    })
    .catch((err)=>{
        return err.response.data
    })

    return response;
}


export const forgotPasswordServer=async(data)=>{
 const response = await httpAxios.post('/forget-password',data).then((res)=>{
    return res.data
 }).catch((err)=>{
    return err.response.data
});
return response;
}
export const restPasswordServer=async(data,token)=>{
 const response = await httpAxios.post(`/reset-password/${token}`,data).then((res)=>{
    return res.data
 }).catch((err)=>{
    return err.response.data
});
return response;
}
export const authLogout = async(data)=>{
    const response = await httpAxios.post('/logout',data)
    .then((res)=>{
        return res.data
    })
    .catch((err)=>{
        return err.response.data
    })

    return response;
}


